import React from 'react';
import EntitiesAuditDownloadModal from './EntitiesAuditDownloadModal';
import EntitiesAuditCategoriesTable from './EntitiesAuditCategoriesTable';
import EntitiesAuditEntitiesTable from './EntitiesAuditEntitiesTable';
import RadioGroup from '../../../reusable/Form/RadioGroup';
import { FormattedMessage } from 'react-intl';
import FileDownload from './FileDownload';

let dateFormat = require('dateformat');

export default class EntitiesAuditDownloadModalWrapper extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isModalLoading:        false,
            userSelectionType:     "all_entities",
            selectedEntitiesIds:   [],
            selectedCategoriesIds: [],
            startDownload:         false,
            formDataPayload:       []
        };

        this.isLoadingHandler = this.isLoadingHandler.bind(this);
        this.setUserSelectionType = this.setUserSelectionType.bind(this);
        this.startDownload = this.startDownload.bind(this);
        this.updateEntitiesSelection = this.updateEntitiesSelection.bind(this);
        this.updateCategoriesSelection = this.updateCategoriesSelection.bind(this);
        this.onDownloadComplete = this.onDownloadComplete.bind(this);
    }

    isLoadingHandler(param) {
        this.setState({isModalLoading: param})
    }

    setUserSelectionType(event) {
        this.setState({
            selectedEntitiesIds:   [],
            selectedCategoriesIds: [],
            userSelectionType:     event.target.value
        });
    }

    updateEntitiesSelection(selectedEntitiesIds) {
        this.setState({selectedEntitiesIds, selectedCategoriesIds: null});
    }

    updateCategoriesSelection(selectedCategoriesIds) {
        this.setState({selectedCategoriesIds, selectedEntitiesIds: null});
    }

    startDownload(event) {
        let date = new Date();
        let uiDate = dateFormat(date, "dd mmm yyyy");
        let uiTime = dateFormat(date, "HH:MM");

        let formDataPayload = {
            selectAllEntities: this.state.userSelectionType === "all_entities",
            uiDate,
            uiTime
        }
        if (this.state.userSelectionType === "specific_entities") {
            formDataPayload.selectedEntityIds = this.state.selectedEntitiesIds;
        }
        if (this.state.userSelectionType === "categories") {
            formDataPayload.selectedCategoryIds = this.state.selectedCategoriesIds;
        }

        this.setState({formDataPayload, startDownload: true});
    }

    onDownloadComplete() {
        this.setState({startDownload: false, formDataPayload: []});
        this.props.secondaryAction();
    }

    radioOptions = [
        {
            value: 'all_entities',
            label: <FormattedMessage id="UserAudit_Download_UIText_modalOptions.allEntities" />
        },
        {
            value: 'specific_entities',
            label: <FormattedMessage id="UserAudit_Download_UIText_modalOptions.specificEntities" />,
        },
        {
            value: 'categories',
            label: <FormattedMessage id="UserAudit_Download_UIText_modalOptions.categories" />,
        }
    ];

    render() {
        return (
            <EntitiesAuditDownloadModal modalName={'ModalDownloadEntitiesAudit__' + this.state.userSelectionType}
                                        isModalLoading={this.state.isModalLoading}
                                        isPrimaryButtonDisabled={
                                            (this.state.userSelectionType === 'specific_entities' && this.state.selectedEntitiesIds.length === 0) ||
                                            (this.state.userSelectionType === 'categories' && this.state.selectedCategoriesIds.length === 0)
                                        }
                                        primaryI18n={"UserAudit_Download_UIText_modalActions.download"}
                                        primaryAction={this.startDownload}
                                        secondaryI18n={"General_CoreFunctionality_UIText_general.cancel"}
                                        secondaryAction={this.props.secondaryAction}
                                        title={"UserAudit_Download_UIText_modalTitleEntities"}>
                <div className="download-instructions">
                    <FormattedMessage id="UserAudit_Download_UIText_instructionsEntities" />
                </div>
                <RadioGroup value={this.state.userSelectionType}
                            fieldId={"users-selector"}
                            onChange={this.setUserSelectionType}
                            options={this.radioOptions} />
                {
                    this.state.userSelectionType === 'specific_entities' &&
                    <EntitiesAuditEntitiesTable isLoadingHandler={this.isLoadingHandler}
                                                onUpdateSelection={this.updateEntitiesSelection} />
                }
                {
                    this.state.userSelectionType === 'categories' &&
                    <EntitiesAuditCategoriesTable isLoadingHandler={this.isLoadingHandler}
                                                  onUpdateSelection={this.updateCategoriesSelection} />
                }
                {this.state.startDownload &&
                <FileDownload
                    queryParams={this.state.formDataPayload}
                    actionPath={"/api/audit/download/entity-audit"}
                    onDownloadComplete={this.onDownloadComplete}
                />
                }
            </EntitiesAuditDownloadModal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/AccountUsage/Components/EntitiesAuditDownloadModalWrapper.jsx